import createModel from 'utils/model'
import {getCustomerGrouping, getGroupGrouping} from 'crm/services/grouping'

export default createModel({
    namespace: 'crm_grouping',
    state: {},

    subscriptions: {},

    effects: {
        *getCustomerGrouping({payload}, {call}) {
            return yield call(getCustomerGrouping, payload)
        },
        *getGroupGrouping({payload}, {call}) {
            return yield call(getGroupGrouping, payload)
        },
    },

    reducers: {},
})
